import { z } from "zod";

export const ZSegments = z.object({
  nombre: z.string(),
  descripcion: z.string(),
  activo: z.union([z.string(), z.number()]),
});

